module.exports = __webpack_public_path__ + "media/images/battery-40-09935f668919a696c279293ca176970f.png";